/**
 * Spielversion.
 *
 * Vite ersetzt `__GAME_VERSION__` beim Bauen durch den Wert aus der
 * package.json — so gibt es genau eine Stelle, an der die Version steht, und
 * sie kann nicht auseinanderlaufen.
 */
declare const __GAME_VERSION__: string;

export const GAME_VERSION: string =
  typeof __GAME_VERSION__ === 'string' ? __GAME_VERSION__ : '0.0.0-dev';
